<template>
    <div class="z-10" :id="'area-' + area.id">
        <button class="area btn btn-neutral btn-sm gap-2" @click="flyTo">
                <img :src="area.image_url" alt="" class="inline w-5 h-5 rounded-full" loading="lazy"/>
                <span class="area-title break-words">
                    {{ area.title }}
                </span>
                <div
                    class="badge badge-accent ml-2"
                    v-if="area.number_of_locations"
                >
                    {{ area.number_of_locations }}
                </div>
        </button>
    </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';

export default {
    props: {
        mySmartMap: {
            type: Object,
            default: function () {
                return null;
            }
        },
        area: {
            type: Object,
            required: true
        }
    },
    methods: {
        flyTo() {
            this.triggerEventGA('click_area', {
                id: this.area.id,
                title: this.area.title
            });
            this.mySmartMap.flyTo({
                center: this.area.coordinates,
                zoom: this.area.click_zoom,
                speed: 1.8
            });
        }
    },
    mounted() {
        new mapboxgl.Marker(this.$el).setLngLat(this.area.coordinates).addTo(this.mySmartMap);
    }
};
</script>
<style>
	.area::before {
    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMyIgaGVpZ2h0PSIzIiB2aWV3Qm94PSIwIDAgMyAzIj4gPGRlZnM+IDxjbGlwUGF0aCBpZD0iY2xpcC1NYXJrZXIiPiA8cmVjdCB3aWR0aD0iMyIgaGVpZ2h0PSIzIi8+IDwvY2xpcFBhdGg+IDwvZGVmcz4gPGcgaWQ9Ik1hcmtlciIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtTWFya2VyKSI+IDxwYXRoIGlkPSLjg5HjgrlfMzIyNiIgZGF0YS1uYW1lPSLjg5HjgrkgMzIyNiIgZD0iTTI1LjU1NSwxMC4wMjZhNC4yMTQsNC4yMTQsMCwwLDAtMS45MjIsNy42NDlBNS4yOTIsNS4yOTIsMCwwLDEsMjUuOSwyMS4yMTZsLjAxOC4xMjFhLjE2Ny4xNjcsMCwwLDAsLjMzMSwwbC4wNC0uMjY1YTUuMTA3LDUuMTA3LDAsMCwxLDIuMTY2LTMuNDA2LDQuMjE1LDQuMjE1LDAsMCwwLTIuOS03LjY0Wm0uNDgxLDUuODM0YTEuNjQ3LDEuNjQ3LDAsMSwxLDEuNjQ3LTEuNjQ3QTEuNjQ3LDEuNjQ3LDAsMCwxLDI2LjAzNiwxNS44NjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy41MjUgMjEuNDgpIHJvdGF0ZSgxODApIi8+IDwvZz48L3N2Zz4=");
    mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMyIgaGVpZ2h0PSIzIiB2aWV3Qm94PSIwIDAgMyAzIj4gPGRlZnM+IDxjbGlwUGF0aCBpZD0iY2xpcC1NYXJrZXIiPiA8cmVjdCB3aWR0aD0iMyIgaGVpZ2h0PSIzIi8+IDwvY2xpcFBhdGg+IDwvZGVmcz4gPGcgaWQ9Ik1hcmtlciIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtTWFya2VyKSI+IDxwYXRoIGlkPSLjg5HjgrlfMzIyNiIgZGF0YS1uYW1lPSLjg5HjgrkgMzIyNiIgZD0iTTI1LjU1NSwxMC4wMjZhNC4yMTQsNC4yMTQsMCwwLDAtMS45MjIsNy42NDlBNS4yOTIsNS4yOTIsMCwwLDEsMjUuOSwyMS4yMTZsLjAxOC4xMjFhLjE2Ny4xNjcsMCwwLDAsLjMzMSwwbC4wNC0uMjY1YTUuMTA3LDUuMTA3LDAsMCwxLDIuMTY2LTMuNDA2LDQuMjE1LDQuMjE1LDAsMCwwLTIuOS03LjY0Wm0uNDgxLDUuODM0YTEuNjQ3LDEuNjQ3LDAsMSwxLDEuNjQ3LTEuNjQ3QTEuNjQ3LDEuNjQ3LDAsMCwxLDI2LjAzNiwxNS44NjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy41MjUgMjEuNDgpIHJvdGF0ZSgxODApIi8+IDwvZz48L3N2Zz4=");
    position: absolute;
    height: 3.2rem;
    width: 1rem;
    transform: rotate(180deg);
    background-color: inherit;
    content: "";
    -webkit-mask-size: contain;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    }
    .area{
    top: -1.4rem;
    position: relative;
}
</style>